<template>
  <div class="doink">
    <div class="offline-msg">
      <p v-t>Ugh, no internet. You’re in temporary read-only mode.</p>
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import t from 'vuedirectives/t'

export default {
  directives: { t },
}
</script>

<style lang="scss" scoped>
@import './../../assets/stylesheets/3/modules/all';

.offline {
  z-index: 9001;
  position: fixed;
  left: 0;
  top: 0;
  background-color: rgba($text-color, 0.2);
  width: 100vw;
  @include vh100;
}

.offline-msg {
  position: fixed;
  z-index: 9002;
  color: white;
  left: 0;
  right: 0;
  margin-right: auto;
  margin-left: auto;
  text-align: center;
  margin-top: 3%;

  p {
    display: inline-block;
    padding: 14px 24px;
    color: white;
    background-color: rgba($base-color, 0.75);
    border-radius: 2px;
    @include shadow-z3;
  }
}
</style>
